import styled from 'styled-components';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;
`;

export const Section = styled.section`
  scroll-margin-top: 96px; /* să nu intre sub navbar la ancoră */

  @media (max-width: 768px) {
    padding: 1.5rem 0;
  }
`;
